let ManageAccount = {
    store: {
        namespaced: true
    },
    components: {},
    api: {}
};